import { render, staticRenderFns } from "./reward.vue?vue&type=template&id=678e3c3a&scoped=true&"
import script from "./reward.vue?vue&type=script&lang=js&"
export * from "./reward.vue?vue&type=script&lang=js&"
import style0 from "./reward.vue?vue&type=style&index=0&id=678e3c3a&lang=scss&scoped=true&"
import style1 from "./reward.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678e3c3a",
  null
  
)

export default component.exports